import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MultiMatrix } from '@shared/models/question-types/multi-matrix';
import { SafeHtmlPipe } from '../../../../../../../shared/pipes/safe-html.pipe';
import { ToValidIdPipe } from '../../../../../../../shared/pipes/to-valid-id.pipe';
import { MatrixColumnWidthUtil } from '../../../../../../../shared/utils/matrix-column-width.util';

@Component({
  selector: 'app-multi-matrix-table-head',
  imports: [CommonModule, SafeHtmlPipe, ToValidIdPipe],
  templateUrl: './multi-matrix-table-head.component.html',
  styleUrl: './multi-matrix-table-head.component.scss',
})
export class MultiMatrixTableHeadComponent {
  @Input({ required: true }) multiMatrixQuestion!: MultiMatrix;
  @Input() idPrefix = '';

  /**
   * Calculate the width for each column based on the number of alternatives
   * and the longest alternative title length.
   */
  getColumnWidth(
    alternativesCount: number,
    alternatives?: { title: string }[],
    questionId?: string,
  ): string {
    return MatrixColumnWidthUtil.getColumnWidth(
      alternativesCount,
      alternatives,
      questionId,
      'multi-matrix',
    );
  }

  getColumnMinWidth(title: string, questionId?: string): string {
    return MatrixColumnWidthUtil.getColumnMinWidth(title, questionId);
  }
}
